@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';

.toggle-sidebar-button {
  display: inherit;
  align-items: center;
  justify-content: space-around;
  white-space: nowrap;
}

.products-header-container {
  align-items: center;
}

.plan-features-trial-upsell-banner {
  margin: @space-16;
}
